import React from "react"
import ModalReportSelect_ReportPreview from "../report-preview";


type Props = {
    // search
    searchValue     : string
    searchResults   : any[]

    onSelectReport  : callback
}

export default function ModalReportSelect_SearchResults(props: Props) {

    return (
        <>
            {_.isEmpty(props.searchResults) && (
                <div className="flex-row-center-center h-500 w-100-percent">
                    <div className="ui5-txt-not-important">No results found</div>
                </div>
            )}

            {props.searchResults.map((model: any, key) => {
                return <ModalReportSelect_ReportPreview key={key} report={model} onSelectReport={props.onSelectReport}/>
            })}
        </>
    );
}
